import type { HealthCheckResult, HealthPort, ModuleState } from '@ochal/module-sdk/contracts';

export interface ModuleHealthSnapshot { moduleId: string; state: ModuleState; result: HealthCheckResult; updatedAt: number }
export class HealthRegistry implements HealthPort {
  private readonly entries = new Map<string, ModuleHealthSnapshot>();
  report(moduleId: string, result: HealthCheckResult): void { const previous = this.entries.get(moduleId); this.entries.set(moduleId, { moduleId, state: previous?.state ?? 'discovered', result: Object.freeze({ ...result }), updatedAt: Date.now() }); }
  setState(moduleId: string, state: ModuleState, message?: string): void {
    const current = this.entries.get(moduleId)?.result ?? { status: state === 'active' ? 'healthy' : state === 'failed' || state === 'blocked' ? 'unhealthy' : 'degraded' };
    this.entries.set(moduleId, { moduleId, state, result: message ? { ...current, message } : current, updatedAt: Date.now() });
  }
  get(moduleId: string): ModuleHealthSnapshot | undefined { return this.entries.get(moduleId); }
  snapshot(): readonly ModuleHealthSnapshot[] { return [...this.entries.values()]; }
  clear(): void { this.entries.clear(); }
}
